import classNames from './GenericErrorModal.module.scss';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';
import SVG from 'react-inlinesvg';
import oops from '@/assets/svg/oops.svg';

interface GenericErrorModalProps {
  show: boolean;
  title?: string;
  message?: string;
  i18nKey?: string;
  eyebrow?: string;
  buttonText?: string;
  icon?: string;
  onClose: () => void;
}

const GenericErrorModal = ({
  show,
  title,
  message,
  i18nKey,
  eyebrow,
  buttonText,
  icon,
  onClose,
}: GenericErrorModalProps) => {
  /** Admin-only keys live in the `admin` namespace; teacher strings use `translation`. */
  const { t } = useTranslation(['translation', 'admin']);

  const finalTitle = title?.trim() || t('error.weHadAProblem');
  const finalMessage = i18nKey?.trim()
    ? t(i18nKey)
    : message?.trim() || t('error.somethingWentWrong');
  const finalButtonText = buttonText?.trim() || (t('ok') as string);

  return (
    <Transition in={show} timeout={400} mountOnEnter unmountOnExit>
      {state => (
        <>
          <AppBackdrop className={classnames(classNames.backdrop, `backdrop-${state}`)} />
          <AppModal className={classNames.appModal}>
            <div className={classnames(classNames.modal, `fade-${state}`)}>
              <SVG src={icon || oops} />
              {eyebrow && <span className={classNames.eyebrow}>{eyebrow}</span>}
              <h2>{finalTitle}</h2>
              {finalMessage && <span className={classNames.description}>{finalMessage}</span>}
              <TheButton
                className={classNames.closeBtn}
                text={finalButtonText}
                shouldRecolor={false}
                emitOnClick={onClose}
              />
            </div>
          </AppModal>
        </>
      )}
    </Transition>
  );
};

export default GenericErrorModal;
